import React from 'react';

export default function Switch({ lable, name, ...props }) {
    return (
        <div className="flex items-center gap-x-3">
            <label htmlFor={name} className="relative inline-block h-5 cursor-pointer w-9">
                <input type="checkbox" id={name} name={name} className="sr-only peer" {...props} />
                <span className="absolute inset-0 transition-colors duration-200 ease-in-out bg-gray-200 rounded-full peer-checked:bg-main-color dark:bg-neutral-700 dark:peer-checked:bg-main-color peer-disabled:opacity-50 peer-disabled:pointer-events-none"></span>
                <span className="absolute top-1/2 start-0.5 -translate-y-1/2 size-4 bg-white rounded-full shadow-xs transition-transform duration-200 ease-in-out peer-checked:translate-x-full dark:bg-neutral-400 dark:peer-checked:bg-white"></span>
            </label>
            <label htmlFor={name} className="text-sm text-gray-500 dark:text-neutral-400">
                {lable}
            </label>
        </div>
    );
}
